export default __webpack_public_path__ + "imgs/51c6b83e.png";